/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_StatsInputs */

const en_ui_stat_stats = /** @type {(inputs: Ui_Stat_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

const de_ui_stat_stats = /** @type {(inputs: Ui_Stat_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken`)
};

/**
* | output |
* | --- |
* | "Stats" |
*
* @param {Ui_Stat_StatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_stats = /** @type {((inputs?: Ui_Stat_StatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_StatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_stats(inputs)
	return de_ui_stat_stats(inputs)
});